import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ChipSelector, { ChipOption } from "../../../common/form/ChipSelect/ChipSelector";

interface Props {
  value: string[];
  onChange: (value: string[]) => void;
}

export default function ContinuingEducationEditor({ value, onChange }: Props) {
  const { t } = useTranslation();
  const continuingEducationOptions: ChipOption[] = useMemo(
    () => [
      { key: "workforce_development", value: t("text.companion_onboarding_continuing_workforce_development") },
      { key: "cultural_enrichment", value: t("text.companion_onboarding_continuing_cultural_enrichment") },
    ],
    [t]
  );

  return (
    <ChipSelector
      options={continuingEducationOptions}
      selectedKeys={value ?? []}
      onSelectionChange={onChange}
      multiSelect
    />
  );
}
